import React from 'react';
import localizedStrings from 'localization';
import {
  ContainerGeneralInfo,
  GeneralInfoFlex,
  PublishShowcaseGeneralLabels,
  ShowcaseInput,
} from 'modules/profile/components';
import { StepPropsSplit } from './typings';
import { FieldErrorMessage } from 'components/input-field/components';
import { SeparatorInputs } from 'components/week-progress-timeline/components';

const GeneralInfo = (props: StepPropsSplit) => {
  return (
    <ContainerGeneralInfo>
      <GeneralInfoFlex>
        <PublishShowcaseGeneralLabels>
          {localizedStrings.selectShowcaseCallToAction}
        </PublishShowcaseGeneralLabels>
        <ShowcaseInput max={200} maxLength={200} name="callToAction" defaultValue={props.values.callToAction} data-testid="ShowcaseInput-callToAction" />
        {!props.values.callToAction ? (
          <FieldErrorMessage>
            {localizedStrings.requiredField}
          </FieldErrorMessage>
        ) : null}
      </GeneralInfoFlex>
      <SeparatorInputs />
      <GeneralInfoFlex>
        <PublishShowcaseGeneralLabels>
          {localizedStrings.selectShowcaseName}
        </PublishShowcaseGeneralLabels>
        <ShowcaseInput max={200} maxLength={200} name="name" defaultValue={props.values.name} data-testid="ShowcaseInput-name"/>
        {!props.values.name ? (
          <FieldErrorMessage>
            {localizedStrings.requiredField}
          </FieldErrorMessage>
        ) : null}
      </GeneralInfoFlex>
    </ContainerGeneralInfo>
  );
};

export default GeneralInfo;
